import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, onMounted, watch } from 'vue'
import { LayerSpecification } from 'mapbox-gl'
import { useMapBox } from './composables/useMapBox'

export interface Props {
	spec: LayerSpecification
	beforeId?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBoxLayer',
  props: {
    spec: null,
    beforeId: null
  },
  setup(__props: any) {

const props = __props as { spec: LayerSpecification, beforeId?: string };



const { map } = useMapBox()

function removeLayer() {
	if (typeof map?.value?.getLayer(props.spec.id) !== 'undefined') {
		map.value?.removeLayer(props.spec.id)
	}
}

onMounted(() => {
	removeLayer()
	map?.value?.addLayer(props.spec, props.beforeId)
})

watch(
	() => (props.spec as any).layout?.visibility,
	(value) => {
		if (!map?.value) return
		if (typeof map.value.getLayer(props.spec.id) === 'undefined') return
		map.value.setLayoutProperty(props.spec.id, 'visibility', value ?? 'visible')
	},
)

onUnmounted(() => {
	removeLayer()
})

return { __sfc: true,props, map, removeLayer }
}

})